module.exports = __webpack_public_path__ + "9c2dc6feddfcf7b76ab057e78425ce49.woff2";